import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import { Typography } from "@mui/material";
import { SimpleTreeView } from "@mui/x-tree-view";
import { useEffect, useState } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { IItem, InboxStructureTree } from "../../../../store/state/inboxStructure/types";
import InvestorTree from "./InvestorTree";

interface Props {
  selectedItem: string;
  inboxStructure: InboxStructureTree;
  onItemSelected: (item: string) => void;
}

const InvestorMenu = ({ selectedItem, inboxStructure, onItemSelected }: Props) => {
  const [expandedTags, setExpandedTags] = useState<string[]>([]);

  useEffect(() => {
    const tags = selectedItem.split("/");
    const expanded = tags.length > 1 ? [defined(tags[0])] : [];
    // eslint-disable-next-line @eslint-react/set-state-in-effect
    setExpandedTags(expanded);
  }, [selectedItem]);

  return (
    <>
      <Typography variant="subtitle2" color="textPrimary" sx={{ py: 1 }}>
        Investors
      </Typography>
      <SimpleTreeView
        selectedItems={selectedItem}
        expandedItems={expandedTags}
        onExpandedItemsChange={(_, nodeIds) => setExpandedTags(nodeIds)}
        expansionTrigger="iconContainer"
        slots={{ collapseIcon: ExpandMoreIcon, expandIcon: ChevronRightIcon }}
      >
        <InvestorTree inboxStructure={inboxStructure["systemTags"] as IItem[]} onItemSelected={onItemSelected} />
      </SimpleTreeView>
    </>
  );
};

export default InvestorMenu;
